export default __webpack_public_path__ + "img/af7246263bb11345a191392f50e359cf.svg";